import { Injectable } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class TextAnalyticsService {

  constructor(
    private _utilsService: UtilsService
  ) { }

  getComments(brand_id, group_id, shop_id, from_date, to_date, primary_rating, feedback_id, field_id, date_filter_type, limit, page_number, comment_keyword_switch, is_sentiment_allowed, rater_type, keyword, search_type, search_text, filters, customFilterList) {
    const reqBody = {
      brand_id: brand_id,
      group_id: group_id,
      shop_id: shop_id,
      from: from_date,
      to: to_date,
      limit: limit,
      feed_id: feedback_id,
      primary_rating: primary_rating,
      field_id: field_id,
      date_filter_type: date_filter_type,
      page_number: page_number,
      comment_keyword_switch: comment_keyword_switch,
      is_sentiment_allowed: is_sentiment_allowed,
      rater_type: rater_type,
      comment_keyword: keyword,
      search_type: search_type,
      search_text: null,
      filters: filters,
      custom_filter_list: customFilterList
    }
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.comments);
    return this._utilsService.postAPICall(url, reqBody, this._utilsService.setHeaders())

  }


  getGrams(brand_id, group_id, shop_id, from, to, rating, feedback_id, field_id, date_filter_type, limit, rater_type, is_sentiment_allowed, n_gram_type, show_hashtags, filters, customFilterList) {
    const reqBody = {
      brand_id: brand_id,
      group_id: group_id,
      shop_id: shop_id,
      from: from,
      to: to,
      limit: limit,
      feed_id: feedback_id,
      primary_rating: rating,
      field_id: field_id,
      date_filter_type: date_filter_type,
      is_sentiment_allowed: is_sentiment_allowed,
      rater_type: rater_type,
      n_gram_type: n_gram_type,
      show_hashtags: show_hashtags,
      filters: filters,
      custom_filter_list: customFilterList
    }
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.getNGrams);
    return this._utilsService.postAPICall(url, reqBody, this._utilsService.setHeaders())

  }


  getHash(brand_id, group_id, shop_id, from, to, rating, feedback_id, field_id, date_filter_type, limit, rater_type, is_sentiment_allowed, n_gram_type, show_hashtags, filters, customFilterList) {
    const reqBody = {
      brand_id: brand_id,
      group_id: group_id,
      shop_id: shop_id,
      from: from,
      to: to,
      limit: limit,
      feed_id: feedback_id,
      primary_rating: rating,
      field_id: field_id,
      date_filter_type: date_filter_type,
      is_sentiment_allowed: is_sentiment_allowed,
      rater_type: rater_type,
      n_gram_type: n_gram_type,
      show_hashtags: show_hashtags,
      filters: filters,
      custom_filter_list: customFilterList
    }
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.getNGrams);
    return this._utilsService.postAPICall(url, reqBody, this._utilsService.setHeaders())

  }

  getLinkedWords(brand_id, group_id, shop_id, from, to, rating, feedback_id, field_id, date_filter_type, limit, rater_type, is_sentiment_allowed, filters, customFilterList) {
    const reqBody = {
      brand_id: brand_id,
      group_id: group_id,
      shop_id: shop_id,
      from: from,
      to: to,
      limit: limit,
      feed_id: feedback_id,
      primary_rating: rating,
      field_id: field_id,
      date_filter_type: date_filter_type,
      is_sentiment_allowed: is_sentiment_allowed,
      rater_type: rater_type,
      filters: filters,
      custom_filter_list: customFilterList
    }
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.linkedWords);
    return this._utilsService.postAPICall(url, reqBody, this._utilsService.setHeaders())
  }

  getKeyDistribution(brand_id, group_id, shop_id, from, to, rating, feedback_id, field_id, date_filter_type, limit, rater_type, is_sentiment_allowed, n_gram_type, search_text, show_hashtags, filters, customFilterList) {
    const reqBody = {
      brand_id: brand_id,
      group_id: group_id,
      shop_id: shop_id,
      from: from,
      to: to,
      limit: limit,
      feed_id: feedback_id,
      primary_rating: rating,
      field_id: field_id,
      date_filter_type: date_filter_type,
      is_sentiment_allowed: is_sentiment_allowed,
      rater_type: rater_type,
      n_gram_type: n_gram_type,
      comment_keyword: search_text,
      show_hashtags: show_hashtags,
      filters: filters,
      custom_filter_list: customFilterList
    }
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.keywordsTrends);
    return this._utilsService.postAPICall(url, reqBody, this._utilsService.setHeaders())
  }

  getHashKeyDistribution(brand_id, group_id, shop_id, from, to, rating, feedback_id, field_id, date_filter_type, limit, rater_type, is_sentiment_allowed, n_gram_type, search_text, show_hashtags, filters, customFilterList) {
    const reqBody = {
      brand_id: brand_id,
      group_id: group_id,
      shop_id: shop_id,
      from: from,
      to: to,
      limit: limit,
      feed_id: feedback_id,
      primary_rating: rating,
      field_id: field_id,
      date_filter_type: date_filter_type,
      is_sentiment_allowed: is_sentiment_allowed,
      rater_type: rater_type,
      n_gram_type: n_gram_type,
      comment_keyword: search_text,
      show_hashtags: show_hashtags,
      filters: filters,
      custom_filter_list: customFilterList
    }
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.keywordsTrends);
    return this._utilsService.postAPICall(url, reqBody, this._utilsService.setHeaders())
  }

  getNoiseAndInterestWords(brand_id) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.noiseAndInterestWords);
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams({
      brand_id: brand_id
    }))
  }

  addToNoiseWordList(brand_id, text) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.noiseWordList);
    return this._utilsService.postAPICall(url,{
      keyword: text,
      brand_id: brand_id
    }, this._utilsService.setHeaders());
  }

  addToInterestWordList(brand_id, text) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.interestWordList);
    return this._utilsService.postAPICall(url,{
      keyword: text,
      brand_id: brand_id
    }, this._utilsService.setHeaders());
  }

  removeFromInterestWordList(brand_id, text) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.interestWordList);
    return this._utilsService.deleteAPICall(url,{
      keyword: text,
      brand_id: brand_id
    }, this._utilsService.setHeaders());
  }

  removeFromNoiseWordList(brand_id, text) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.noiseWordList);
    return this._utilsService.deleteAPICall(url,{
      keyword: text,
      brand_id: brand_id
    }, this._utilsService.setHeaders());
  }

  getText(rqst_object) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.getText);
    return this._utilsService.postAPICall(url,rqst_object, this._utilsService.setHeaders());
  }

  getFeeds(rqst_object) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.comment);
    return this._utilsService.postAPICall(url,rqst_object, this._utilsService.setHeaders());

  }

  compareTags(rqst_object) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.compareTags);
    return this._utilsService.postAPICall(url,rqst_object, this._utilsService.setHeaders());
  }

  getOverallText(rqst_object) {
    if (!_.isEmpty(Helpers.universalFilter)) {
      rqst_object.universal_filter = Helpers.getUniversalFilter();
    }
    const url = this._utilsService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.overallText);
    return this._utilsService.postAPICall(url,rqst_object, this._utilsService.setHeaders());
  }

  getSummaryTrends(rqst_object) {
    if (!_.isEmpty(Helpers.universalFilter)) {
      rqst_object.universal_filter = Helpers.getUniversalFilter();
    }
    const url = this._utilsService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.trendSummary);
    return this._utilsService.postAPICall(url,rqst_object, this._utilsService.setHeaders());

  }


  getKeyWords(params) {
    if (!_.isEmpty(Helpers.universalFilter)) {
      params.universal_filter = Helpers.getUniversalFilter();
    }
    const url = this._utilsService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.wordcloud);
    return this._utilsService.postAPICall(url,params, this._utilsService.setHeaders());
  }

  getCommentsV2(params) {
    if (!_.isEmpty(Helpers.universalFilter)) {
      params.universal_filter = Helpers.getUniversalFilter();
    }
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.commentsV2);
    return this._utilsService.postAPICall(url,params, this._utilsService.setHeaders());
  }
}
